import * as React from 'react';

function useStorage(key = '') {
  const checkData  = React.useCallback(() => {
    try {
      return JSON.parse(sessionStorage.getItem(key));
    } catch (e) {
      return null;
    }
  }, []);
  const getData    = React.useCallback(() => {
    const data = JSON.parse(sessionStorage.getItem(key));

    if (data && Object.keys(data).length > 0) {
      return Promise.resolve({ ...data });
    }

    throw Error;
  }, []);
  const hasData    = React.useCallback(() => {
    const data = JSON.parse(sessionStorage.getItem(key));

    return data && Object.keys(data).length > 0;
  }, []);
  const removeData = React.useCallback(() => {
    if (sessionStorage.getItem(key)) {
      sessionStorage.removeItem(key);
    }
  }, []);
  const setData    = React.useCallback((data) => {
    sessionStorage.setItem(key, JSON.stringify(data));
  }, []);

  return React.useMemo(() => ({
    checkData,
    getData,
    hasData,
    removeData,
    setData,
  }), [checkData, getData, hasData, removeData, setData]);
}

export default useStorage;